import React from "react";
import phone from "../assets/imagesLand/phone2.png";
import google from "../assets/imagesLand/google1.png";
import apple from "../assets/imagesLand/APPLE.png";
import { useGoToLandingSection } from "../hooks/useGoToLandingSection";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.easymarketpro.dev";
const APP_STORE_URL =
  "https://apps.apple.com/sn/app/easy-market-pro/id6472059740";

export default function Hero() {
  const goToContact = useGoToLandingSection();

  const hoverOn = e => {
    e.currentTarget.style.transform = 'translateY(-2px)';
    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.12)';
  };
  const hoverOff = e => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.2)';
  };

  return (
    <section className="relative bg-[#053965] flex flex-col items-center justify-start overflow-hidden pt-[80px]">

      {/* Glow */}
      <div className="absolute w-[900px] h-[910px] top-[80px] left-1/2 -translate-x-1/2 rounded-full " />

      {/* Titre */}
      <h1 className="text-center z-10 px-4 text-white font-extrabold mt-[30px] leading-[1.2] tracking-[-0.5px] text-[clamp(28px,5.5vw,55px)] font-[Montserrat,sans-serif]">
        Votre commerce,{" "}
        <span className="text-[#F59E0B]">sous contrôle</span>{" "}
        24h/24.
      </h1>

      {/* Sous-titre */}
      <p className="text-center z-10 px-4 text-white/90 mt-4 leading-[1.6] max-w-[600px] text-[clamp(18px,3vw,24px)] font-semibold font-[Montserrat]">
        Stock, caisse, ventes, tout en temps réel depuis votre téléphone.
      </p>

      {/* ── MOBILE & TABLETTE : CTA + badges empilés ── */}
      <div className="md:hidden z-10 flex flex-col items-center gap-3 mt-6 px-4 w-full">

        {/* CTA */}
        
        <a
          href="/#contact"
          onClick={(e) => {
            e.preventDefault();
            goToContact("contact");
          }}
          className="bg-[#F59E0B] text-white font-bold text-[15px] rounded-full px-10 py-3 no-underline transition-all duration-200 hover:bg-[#d97706] hover:scale-105 w-full max-w-[320px] text-center shadow-md"
        >
          Demo gratuite
        </a>

        {/* Badges côte à côte */}
        <div className="flex gap-3 justify-center">
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Télécharger EasyMarket Pro sur Google Play"
            className="flex items-center justify-center w-[148px] h-[52px] bg-white border border-[#e0e0e0] rounded-lg cursor-pointer shadow-[0_4px_20px_rgba(0,0,0,0.2)] transition-all duration-200 no-underline"
            onMouseEnter={hoverOn}
            onMouseLeave={hoverOff}
          >
            <img src={google} alt="Get it on Google Play" className="h-[32px] object-contain" />
          </a>
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Télécharger EasyMarket Pro sur l'App Store"
            className="flex items-center justify-center w-[148px] h-[52px] bg-white border border-[#e0e0e0] rounded-lg cursor-pointer shadow-[0_4px_20px_rgba(0,0,0,0.2)] transition-all duration-200 no-underline"
            onMouseEnter={hoverOn}
            onMouseLeave={hoverOff}
          >
            <img src={apple} alt="Download on the App Store" className="h-[32px] object-contain" />
          </a>
        </div>
      </div>

      {/* ── PHONE + badges flottants (desktop seulement) ── */}
      <div className="relative z-10 mt-8 w-full max-w-[860px] flex justify-center items-start">

        {/* GOOGLE PLAY — desktop uniquement */}
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Télécharger EasyMarket Pro sur Google Play"
          className="hidden md:flex items-center justify-center w-[190px] h-[66px]
            bg-white border border-[#e0e0e0] rounded-lg cursor-pointer
            absolute top-[100px] left-[8px]
            shadow-[0_4px_20px_rgba(0,0,0,0.2)] transition-all duration-200"
          onMouseEnter={hoverOn}
          onMouseLeave={hoverOff}
        >
          <img src={google} alt="Get it on Google Play" className="h-[40px] object-center" />
        </a>

        {/* PHONE */}
        <img
          src={phone}
          alt="phone"
          className="w-[220px] sm:w-[400px] block relative z-[2] -mb-[320px] drop-shadow-[0_30px_60px_rgba(0,0,0,0.5)]"
        />

        {/* APP STORE — desktop uniquement */}
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Télécharger EasyMarket Pro sur l'App Store"
          className="hidden md:flex items-center justify-center w-[190px] h-[66px]
            bg-white border border-[#e0e0e0] rounded-lg cursor-pointer
            absolute top-[100px] right-[8px]
            shadow-[0_4px_20px_rgba(0,0,0,0.2)] transition-all duration-200"
          onMouseEnter={hoverOn}
          onMouseLeave={hoverOff}
        >
          <img src={apple} alt="Download on the App Store" className="h-[40px] object-center" />
        </a>

      </div>
    </section>
  );
}